// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  roomId: __t.u64().primaryKey().name("room_id"),
  kind: __t.string(),
  refKey: __t.string().name("ref_key"),
  name: __t.string(),
  topic: __t.string(),
  owner: __t.identity(),
  access: __t.string(),
  mode: __t.string(),
  capacity: __t.u32(),
  createdAt: __t.timestamp().name("created_at"),
  lastActiveAt: __t.timestamp().name("last_active_at"),
});
